export default __webpack_public_path__ + "static/media/line.b6f9a764.svg";